import React, { useState, useEffect } from 'react';
import NavigationHeader from '../../components/ui/NavigationHeader';
import InventoryTable from './components/InventoryTable';

const InventoryAnalyticsDashboard = () => {
  const [dateRange, setDateRange] = useState({
    start: new Date(2025, 7, 1), // 1º agosto 2025
    end: new Date(2025, 7, 29),  // 29 agosto 2025
    preset: 'month'
  });

  const [isLoading, setIsLoading] = useState(true);

  const handleDateChange = (newRange) => {
    setDateRange(newRange);
    console.log('Date range changed:', newRange);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <NavigationHeader
          currentDateRange={dateRange}
          onDateChange={handleDateChange}
          notificationCount={3}
          onToggleSidebar={() => {}}
        />
        <main className="pt-16">
          <div className="max-w-7xl mx-auto px-6 py-8">
            <div className="animate-pulse space-y-6">
              <div className="h-8 bg-muted rounded-lg w-64" />
              <div className="h-96 bg-muted rounded-lg" />
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <NavigationHeader
        currentDateRange={dateRange}
        onDateChange={handleDateChange}
        notificationCount={3}
        onToggleSidebar={() => {}}
      />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-6 py-8">
          {/* Cabeçalho da página */}
          <div className="mb-8">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-heading-bold text-foreground mb-2">
                  Análise de Inventário
                </h1>
                <p className="text-muted-foreground font-body-normal">
                  Visão detalhada do estoque consolidado para apoio na tomada de decisão.
                </p>
              </div>

              <div className="text-right">
                <div className="text-sm text-muted-foreground font-caption">
                  Última atualização
                </div>
                <div className="text-sm font-body-medium text-foreground">
                  {new Date()?.toLocaleString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </div>
              </div>
            </div>
          </div>

          {/* ÚNICO BLOCO VISÍVEL: INVENTÁRIO DETALHADO */}
          <InventoryTable />
        </div>
      </main>
    </div>
  );
};

export default InventoryAnalyticsDashboard;
